import * as yup from 'yup';

export const schema = yup.object({
  name: yup.string().required('This field is required'),
  startTime: yup
    .date()
    .typeError('Must be a valid date')
    .required('This field is required')
    .min(
      new Date(new Date().setHours(0, 0, 0, 0)),
      "Start time can't be in the past"
    ),
  getStakingTokenUrl: yup
    .string()
    .required('This field is required')
    .url('Needs to be a url'),
  rewardTokenAmount: yup
    .number()
    .typeError('Must be a number')
    .moreThan(-1, 'Cannot be negative'),
  unlockDays: yup
    .number()
    .typeError('Must be a number')
    .moreThan(0, 'Unlock days must be more than 0')
    .when(['rewardTokenAmount'], (rewardTokenAmount, schema) =>
      schema.min(
        rewardTokenAmount > 0 ? 1 : 0,
        'If you set a reward amount you must set unlock days for that reward'
      )
    ),
  scalingFloor: yup
    .number()
    .typeError('Must be a positive number')
    .positive('Must be a positive number')
    .max(yup.ref('scalingCeiling'), 'Cannot exceed scaling ceiling'),
  scalingCeiling: yup
    .number()
    .typeError('Must be a positive number')
    .positive('Must be a positive number')
    .min(yup.ref('scalingFloor'), 'Cannot be less than scaling floor'),

  scalingDays: yup
    .number()
    .typeError('Must be a positive number')
    .positive('Must be a positive number'),

  templateId: yup
    .string()
    .required('This field is required')
    .matches(/^0x[a-fA-F0-9]{40}$/, 'Must be a valid address'),

  templateName: yup.string().required('This field is required')
});

export const fundRewardTokenSchema = yup.object({
  rewardTokenAmount: yup
    .number()
    .typeError('Must be a number')
    .positive('Must be a positive number'),
  unlockDays: yup
    .number()
    .typeError('Must be a number')
    .moreThan(0, 'Unlock days must be more than 0')
});

export const fundBonusTokenSchema = yup.object({
  bonusTokenAmount: yup
    .number()
    .typeError('Must be a number')
    .moreThan(-1, 'Cannot be negative')
});

export const rescueTokensSchema = yup.object({
  recipient: yup
    .string()
    .required('This field is required')
    .matches(/^0x[a-fA-F0-9]{40}$/, 'Must be a valid address'),
  amount: yup
    .number()
    .typeError('Must be a number')
    .moreThan(0, 'Must be more than 0')
});

export const transferAludelSchema = yup.object({
  address: yup
    .string()
    .required('This field is required')
    .matches(/^0x[a-fA-F0-9]{40}$/, 'Must be a valid address')
});

export const updateVaultFactorySchema = yup.object({
  address: yup
    .string()
    .required('This field is required')
    .matches(/^0x[a-fA-F0-9]{40}$/, 'Must be a valid address')
});

export const transferPowerSchema = yup.object({
  address: yup
    .string()
    .required('This field is required')
    .matches(/^0x[a-fA-F0-9]{40}$/, 'Must be a valid address')
});

export const rescueERC20Schema = yup.object({
  recipient: yup
    .string()
    .required('This field is required')
    .matches(/^0x[a-fA-F0-9]{40}$/, 'Must be a valid address')
});
